export default __webpack_public_path__ + "static/media/center6.fe4849a1.jpg";